<!-- NotFound.svelte -->
<script>
  import { push } from 'svelte-spa-router';
  // 1초 후 홈으로 리디렉션
  setTimeout(() => push('/'), 1000);
</script>

<p>존재하지 않는 경로입니다. 홈으로 이동합니다...</p>